import styled from 'styled-components';

import FullPageScreen from 'components/full-page-screen';

export const StyledFullPageScreen = styled(FullPageScreen)`
  background: ${Styles.color.background};

  h1 {
    text-transform: capitalize;
  }
`;
